// extracted by mini-css-extract-plugin
module.exports = {"loading":"spinner_loading__orE2C","spin":"spinner_spin__Ig8Kp","simple_loading":"spinner_simple_loading__JFena","pulse":"spinner_pulse__Uer6n"};